import { Alert, Button, IconPlus } from '@odekoteam/doppio';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Heading, Paragraph } from 'theme-ui';

export default function Header({
  showAddCollectionToHomepage = true,
}: {
  showAddCollectionToHomepage?: boolean;
}) {
  const navigate = useNavigate();

  return (
    <Box as="header">
      <Box sx={{ mb: 3, mt: 1 }}>
        <Alert variant="info">
          This tool should only be used by Marketing.
        </Alert>
      </Box>
      <Flex sx={{ justifyContent: 'space-between', mb: 3 }}>
        <Box>
          <Heading variant="headingMd">Collections</Heading>
          <Paragraph
            variant="paragraphLg"
            sx={{ color: 'neutralDark', marginTop: '2px' }}
          >
            Manage marketing collections
          </Paragraph>
        </Box>
        <Flex sx={{ gap: 4 }}>
          {showAddCollectionToHomepage && (
            <Button
              variant="secondary"
              onPress={() => navigate('/collections/add-to-homepage')}
            >
              Add Collection to Homepage
            </Button>
          )}
          <Button
            variant="primary"
            iconLeft={<IconPlus />}
            onPress={() => navigate('/collections/new')}
          >
            New Collection
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
}
